import React from 'react'
import { CollectionPlayerVideo, PlaylistPlayerVideo } from '../types'
import { ActiveIndexType } from './types'

export type ViddyCoreContext = {
    indexes: ActiveIndexType
    setIndexes: React.Dispatch<React.SetStateAction<ActiveIndexType>>
    playerVideo: PlaylistPlayerVideo | CollectionPlayerVideo | null
}

export const ViddyCoreContext = React.createContext<ViddyCoreContext>({
    indexes: { mainIndex: 0, subIndexes: [] },
    setIndexes: () => {},
    playerVideo: null,
})
